import { DocumentField, DocumentFieldTypes } from 'Interfaces/DocumentFields';

import { INTERACT_SIZES } from './constants';

function calculateContainerScale(targetWidth: number, containerWidth: number) {
  if (!targetWidth) return;

  return (
    containerWidth /
    (targetWidth + INTERACT_SIZES.rightPagePadding + INTERACT_SIZES.leftPagePadding)
  );
}

export const calculateSizeRatio = (targetWidth: number, container?: HTMLElement | null) =>
  calculateContainerScale(targetWidth, container?.clientWidth ?? window.innerWidth);

function calculatePreviewContainerWidth(container: HTMLElement | null): number {
  let containerWidth = 970;

  if (container) {
    if (container.clientWidth < 768) {
      containerWidth = container.clientWidth - 32;
    } else if (container.clientWidth < 970) {
      containerWidth = container.clientWidth - 48;
    }
  }

  return containerWidth;
}

export const calculatePreviewScale = (
  targetWidth: number,
  container: HTMLElement | null,
) => calculateContainerScale(targetWidth, calculatePreviewContainerWidth(container));

export function updateScrollOnScale({
  anchor,
  element,
  documentScale,
  nextDocumentScale,
}: {
  anchor?: { clientX: number; clientY: number };
  element: HTMLElement | null;
  documentScale: number;
  nextDocumentScale: number;
}) {
  if (element) {
    if (anchor) {
      const rect = element.getBoundingClientRect();
      const dx = anchor.clientX - rect.left;
      const dy = anchor.clientY - rect.top;
      const contentX = (element.scrollLeft + dx) / documentScale;
      const contentY = (element.scrollTop + dy) / documentScale;
      // Update the scroll after changing the scale so that
      // the focus point remains in place
      const newScrollLeft = contentX * nextDocumentScale - dx;
      const newScrollTop = contentY * nextDocumentScale - dy;
      element.scrollLeft = Math.max(0, Math.round(newScrollLeft));
      element.scrollTop = Math.max(0, Math.round(newScrollTop));
    } else {
      element.scrollTop = Math.round(
        (element.scrollTop / documentScale) * nextDocumentScale,
      );
    }
  }
}

export const getMinSize = (type: DocumentFieldTypes) => {
  switch (type) {
    case DocumentFieldTypes.Name:
    case DocumentFieldTypes.Date: {
      return {
        width: 50,
        height: 20,
      };
    }
    default: {
      return {
        width: 15,
        height: 15,
      };
    }
  }
};

export const fieldHasValue = (
  fieldValues: Pick<DocumentField, 'requisiteId' | 'text' | 'checked'>,
  type: DocumentFieldTypes,
) => {
  switch (type) {
    case DocumentFieldTypes.Checkbox: {
      return fieldValues.checked;
    }
    case DocumentFieldTypes.Name:
    case DocumentFieldTypes.Date:
    case DocumentFieldTypes.Text: {
      return fieldValues.text;
    }
    default: {
      return fieldValues.requisiteId;
    }
  }
};

export const changeFieldDropDownPositionInvalidity = (
  event: any,
  isPositionInvalid: boolean,
) => {
  const targetFieldNode = event.dragEvent.target as HTMLDivElement;
  const changingClassName = 'fieldDropDown--invalid';

  if (isPositionInvalid) {
    targetFieldNode.classList.add(changingClassName);
  } else {
    targetFieldNode.classList.remove(changingClassName);
  }
};

export const sortFieldPredicate = (
  firstField: DocumentField,
  secondField: DocumentField,
): number => {
  const pageDiff = firstField.pageNumber - secondField.pageNumber;
  return pageDiff === 0 ? firstField.coordinateY - secondField.coordinateY : pageDiff;
};
